import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';

export interface FirstRunState {
  items: Array<{
    key: 'rates' | 'brand' | 'driver' | 'customer' | 'load';
    done: boolean;
  }>;
  complete: boolean;
  trialEndsAt: string | null;
}

export function useFirstRun(fleetId: string | null, enabled = true) {
  return useQuery({
    queryKey: ['first-run', fleetId ?? ''] as const,
    enabled: Boolean(fleetId) && enabled,
    queryFn: () => api<FirstRunState>(`/v1/fleets/${fleetId}/first-run`),
    staleTime: 15_000,
  });
}
